export { Device } from './device'
export { User } from './user'
export { Package } from './package'
export { SubAccount } from './sub_account'
export { DataSource } from './datasource'
import { fullJsonRegistry } from '../requests/jsonparser'

export function generateRealmModels(): { name: string, properties: any }[] {
    let schemas = new Array();
    Object.keys(fullJsonRegistry).forEach((key) => {
        if (key === 'BaseModel') {
            return
        }
        let object: { properties: { [key: string]: string }, primaryKey?: string, modelName: string, isHelperModel: boolean } = Object.assign({}, fullJsonRegistry[key]);
        if (fullJsonRegistry[key].isHelperModel === false) {
            object.properties = Object.assign(object.properties, fullJsonRegistry['BaseModel'].properties);
        }
        let mappedObject = {};
        Object.keys(object.properties).forEach((key) => {

            if (key === 'id') {
                mappedObject[key] = { 'type': 'string', unique: true }
                return;
            }

            if (typeof object.properties[key] === 'string') {
                switch (object.properties[key].toLowerCase()) {
                    case 'boolean':
                        mappedObject[key] = 'bool';
                        break;
                    case 'boolean?':
                        mappedObject[key] = 'bool?';
                        break;
                    case 'number':
                        mappedObject[key] = 'float';
                        break;
                    case 'number?':
                        mappedObject[key] = 'float?';
                        break;
                    case 'string':
                        mappedObject[key] = 'string';
                        break;
                    case 'string?':
                        mappedObject[key] = 'string?';
                        break;
                    case 'number[]':
                        mappedObject[key] = 'float[]';
                        break;
                    default:
                        mappedObject[key] = object.properties[key];
                        break;
                }
            }
        });

        let scheme: any = {
            name: fullJsonRegistry[key].modelName,
            properties: mappedObject
        }
        if (fullJsonRegistry[key].isHelperModel === false) {
            scheme.primaryKey = 'id';
        }
        schemas.push(scheme)
    });


    return schemas
}


// WEBPACK FOOTER //
// ./src/api/models/index.ts